var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplatesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.25H8C5.93 2.25 4.25 3.93 4.25 6V18C4.25 20.07 5.93 21.75 8 21.75H16C18.07 21.75 19.75 20.07 19.75 18V6C19.75 3.93 18.07 2.25 16 2.25ZM18.25 18C18.25 19.24 17.24 20.25 16 20.25H8C6.76 20.25 5.75 19.24 5.75 18V6C5.75 4.76 6.76 3.75 8 3.75H16C17.24 3.75 18.25 4.76 18.25 6V18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.75H12C12.41 8.75 12.75 8.41 12.75 8C12.75 7.59 12.41 7.25 12 7.25H9C8.59 7.25 8.25 7.59 8.25 8C8.25 8.41 8.59 8.75 9 8.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.25H9C8.59 11.25 8.25 11.59 8.25 12C8.25 12.41 8.59 12.75 9 12.75H15C15.41 12.75 15.75 12.41 15.75 12C15.75 11.59 15.41 11.25 15 11.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.25H9C8.59 15.25 8.25 15.59 8.25 16C8.25 16.41 8.59 16.75 9 16.75H15C15.41 16.75 15.75 16.41 15.75 16C15.75 15.59 15.41 15.25 15 15.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatesIcon);
export default __webpack_public_path__ + "static/media/templates-icon.5a14f576e55f7151d8c5c307173dc9c8.svg";
export { ForwardRef as ReactComponent };